import { createSlice } from "@reduxjs/toolkit";

const STORAGE_KEY = "orderDraft";

const loadDraftFromStorage = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch (e) {
    return null;
  }
};

const saveDraftToStorage = (draft) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(draft));
  } catch (e) {}
};

const clearDraftFromStorage = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (e) {}
};

const initialState = {
  draft: loadDraftFromStorage(), // ✅ refresh survive karega
};

const orderDraftSlice = createSlice({
  name: "orderDraft",
  initialState,
  reducers: {
    saveOrderDraft: (state, action) => {
      state.draft = action.payload;
      saveDraftToStorage(action.payload); // ✅ persist
    },
    clearOrderDraft: (state) => {
      state.draft = null;
      clearDraftFromStorage(); // ✅ clear persist
    },
  },
});

export const { saveOrderDraft, clearOrderDraft } = orderDraftSlice.actions;

export default orderDraftSlice.reducer;
